define('bizzabo/models/Speakers',['bizzabo/models/Speaker', 'bizzabo/models/SyncedCollection'], function(Speaker, SyncedCollection) {

    var Speakers = SyncedCollection.extend({
        model : Speaker
    });

    return Speakers;

});
